import { useState } from 'react'
import CampaignTimeline from '../components/timeline/CampaignTimeline'
import { useCollection } from '../hooks/useFirestore'
import './TimelinePage.css'

export default function TimelinePage() {
  const [activeFilters, setActiveFilters] = useState([])

  const { data: events, loading: eventsLoading, error: eventsError } = useCollection('events')
  const { data: characters, loading: charsLoading } = useCollection('characters')

  // Filter out hidden events and characters from public view
  const visibleEvents = events.filter(e => e.hidden !== true)
  const visibleCharacters = characters.filter(c => c.hidden !== true)

  const loading = eventsLoading || charsLoading

  if (loading) {
    return (
      <div className="container">
        <div className="timeline-loading">
          <div className="loading-spinner" />
          <p>Loading timeline...</p>
        </div>
      </div>
    )
  }

  if (eventsError) {
    return (
      <div className="container">
        <div className="timeline-error">
          <h2>Error loading timeline</h2>
          <p>{eventsError}</p>
        </div>
      </div>
    )
  }

  if (visibleEvents.length === 0) {
    return (
      <div className="container">
        <h1>Campaign Timeline</h1>
        <div className="timeline-empty">
          <p>No events yet.</p>
          <p className="text-secondary">Add events from the Admin section to populate the timeline.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <h1>Campaign Timeline</h1>
      <CampaignTimeline
        events={visibleEvents}
        characters={visibleCharacters}
        activeFilters={activeFilters}
        onFilterChange={setActiveFilters}
      />
    </div>
  )
}
